import { EMPTY_ARRAY } from '@taiga-ui/cdk';

const DEFAULT_MARGIN = 4;
const DEFAULT_MIN_HEIGHT = 80;
const DEFAULT_MAX_HEIGHT = 400;
const DEFAULT_MAX_WIDTH = 600;

const TUI_DECIMAL_SYMBOLS = [',', '.'];

const DEFAULT_ICONS_PATH = name => name.includes('.svg#') ? name : `#${name}`;

const TUI_DEFAULT_MARKER_HANDLER = () => EMPTY_ARRAY;

const tuiEditingKeys = [
    'Spacebar',
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
    'Left',
    'Right',
    'End',
    'Home',
];

/**
 * An event indicating that async data for expand has finished loading.
 * Dispatch to finish loading states for {@link TuiExpandComponent}.
 */
const TUI_EXPAND_LOADED = 'tui-expand-loaded';
/**
 * An event for scrolling an element into view within {@link TuiScrollbarComponent}.
 */
const TUI_SCROLL_INTO_VIEW = 'tui-scroll-into-view';
/**
 * An event to notify {@link TuiScrollbarComponent} that
 * it should control a nested element.
 */
const TUI_SCROLLABLE = 'tui-scrollable';
/**
 * An event indicating and error during icon loading in {@link TuiSvgComponent}.
 */
const TUI_ICON_ERROR = 'tui-icon-error';

const MASK_CARET_TRAP = '[]';

/**
 * Media constants are exact the same as css media breakpoints
 * @deprecated use TUI_MEDIA token
 */
const MEDIA = {
    mobile: 320,
    tablet: 600,
    desktopSmall: 1024,
    desktopLarge: 1280,
};

const TUI_DIGIT_REGEXP = /\d/;
const TUI_NON_DIGIT_REGEXP = /\D/;
const TUI_NON_DIGITS_REGEXP = /\D+/g;
const TUI_LEADING_ZEROES_REGEXP = /^0+/;
const TUI_MASK_SYMBOLS_REGEXP = /[ \-_()]/g;
const TUI_LAST_PUNCTUATION_MARK_REGEXP = /[.,\\/#!$%\\^&\\*;:{}=\\-_`~()]$/;
const TUI_LATIN_REGEXP = /[A-z]/;
const TUI_LATIN_AND_NUMBERS_REGEXP = /[A-z|0-9]/;

const VERSION = '2.42.0';

/**
 * Generated bundle index. Do not edit.
 */

export { DEFAULT_ICONS_PATH, DEFAULT_MARGIN, DEFAULT_MAX_HEIGHT, DEFAULT_MAX_WIDTH, DEFAULT_MIN_HEIGHT, MASK_CARET_TRAP, MEDIA, TUI_DECIMAL_SYMBOLS, TUI_DEFAULT_MARKER_HANDLER, TUI_DIGIT_REGEXP, TUI_EXPAND_LOADED, TUI_ICON_ERROR, TUI_LAST_PUNCTUATION_MARK_REGEXP, TUI_LATIN_AND_NUMBERS_REGEXP, TUI_LATIN_REGEXP, TUI_LEADING_ZEROES_REGEXP, TUI_MASK_SYMBOLS_REGEXP, TUI_NON_DIGITS_REGEXP, TUI_NON_DIGIT_REGEXP, TUI_SCROLLABLE, TUI_SCROLL_INTO_VIEW, VERSION, tuiEditingKeys };

